import { lazy } from 'react';
import type { ModuleDefinition } from '@/shared/types/module';

const AccountPage = lazy(() =>
  import('./AccountPage').then((m) => ({ default: m.AccountPage })),
);

export const accountModule: ModuleDefinition = {
  id: 'account',
  name: 'Account',
  routes: [
    { path: '/account', element: <AccountPage />, handle: { layout: 'app', auth: true } },
  ],
  navigation: [],
};
